export default orderNumber => `${orderNumber.slice(0, 3)}-${orderNumber.slice(3, 6)}`;
